import { render, staticRenderFns } from "./rsvi-tabs.vue?vue&type=template&id=56e02837&scoped=true"
import script from "./rsvi-tabs.vue?vue&type=script&lang=js"
export * from "./rsvi-tabs.vue?vue&type=script&lang=js"
import style0 from "./rsvi-tabs.vue?vue&type=style&index=0&id=56e02837&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e02837",
  null
  
)

export default component.exports